import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { List, Map } from 'immutable';
import ReduxRecord from './reduxRecord';
import QuizSessionEvent from './QuizSessionEvent';
import { AUTOGRADING, CREATING_RESPONSES, CREATING_SESSION_ITEMS, FAILED_TO_START, FAILURE, GRADED, IN_PROGRESS, REOPENING_GRADED, NEEDS_GRADING, PENDING, STARTING } from '@instructure/quiz-common';
import { getQuizById } from '../selectors/quizzes';
import { getQuizSessionResultById, getQuizSessionResultsByIds } from '../selectors/quizSessionResults';
import { getResponsesByIds } from '../selectors/taking';
import { getSessionItemsByIds } from '../selectors/sessionItems';
export var QuizSession = /*#__PURE__*/function (_ReduxRecord) {
  function QuizSession() {
    _classCallCheck(this, QuizSession);
    return _callSuper(this, QuizSession, arguments);
  }
  _inherits(QuizSession, _ReduxRecord);
  return _createClass(QuizSession, [{
    key: "isLoaded",
    value:
    // Helpers
    function isLoaded() {
      return this.id !== '0';
    }
  }, {
    key: "isOneQuestionAtATime",
    value: function isOneQuestionAtATime() {
      return this.oneAtATimeType === 'question';
    }

    // Status helpers
  }, {
    key: "pending",
    value: function pending() {
      return this.status === PENDING;
    }
  }, {
    key: "starting",
    value: function starting() {
      return this.status === STARTING;
    }
  }, {
    key: "creatingSessionItems",
    value: function creatingSessionItems() {
      return this.status === CREATING_SESSION_ITEMS;
    }
  }, {
    key: "failedToStart",
    value: function failedToStart() {
      return this.status === FAILED_TO_START;
    }
  }, {
    key: "inProgress",
    value: function inProgress() {
      return this.status === IN_PROGRESS;
    }
  }, {
    key: "reopeningGraded",
    value: function reopeningGraded() {
      return this.status === REOPENING_GRADED;
    }
  }, {
    key: "creatingResponses",
    value: function creatingResponses() {
      return this.status === CREATING_RESPONSES;
    }
  }, {
    key: "autoGrading",
    value: function autoGrading() {
      return this.status === AUTOGRADING;
    }
  }, {
    key: "needsGrading",
    value: function needsGrading() {
      return this.status === NEEDS_GRADING;
    }
  }, {
    key: "failed",
    value: function failed() {
      return this.status === FAILURE;
    }
  }, {
    key: "graded",
    value: function graded() {
      return this.status === GRADED;
    }
  }, {
    key: "taking",
    value: function taking() {
      return this.starting() || this.creatingSessionItems() || this.inProgress() || this.reopeningGraded();
    }
  }, {
    key: "submitted",
    value: function submitted() {
      return this.creatingResponses() || this.autoGrading() || this.needsGrading() || this.graded() || this.failed();
    }
  }, {
    key: "pins",
    value: function pins() {
      return this.takingData.get('pins') || List();
    }
  }, {
    key: "hasTimeAllowed",
    get: function get() {
      return typeof this.timeAllowed() === 'number';
    }
  }, {
    key: "timeAllowed",
    value: function timeAllowed() {
      return this.takingData.get('timeAllowed');
    }

    // Relationships
  }, {
    key: "getQuiz",
    value: function getQuiz() {
      return getQuizById(this.getState(), this.quiz);
    }
  }, {
    key: "getSessionItems",
    value: function getSessionItems() {
      return getSessionItemsByIds(this.getState(), this.sessionItems);
    }
  }, {
    key: "getQuizSessionResults",
    value: function getQuizSessionResults() {
      return getQuizSessionResultsByIds(this.getState(), this.quizSessionResults);
    }
  }, {
    key: "getResumeData",
    value: function getResumeData() {
      return getResponsesByIds(this.getState(), this.resumeData);
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      return this.getState().getIn(['quizSessionEvents', this.id], List()).map(function (data) {
        return new QuizSessionEvent(data);
      });
    }
  }, {
    key: "findAuthoritativeResult",
    value: function findAuthoritativeResult() {
      return getQuizSessionResultById(this.getState(), this.authoritativeResult);
    }
  }, {
    key: "userDisplayName",
    value: function userDisplayName() {
      // Still accurate?
      var email, fullName, givenName;
      if (this.user) {
        ;
        var _this$user$toJS = this.user.toJS();
        email = _this$user$toJS.email;
        fullName = _this$user$toJS.fullName;
        givenName = _this$user$toJS.givenName;
      }
      return fullName || givenName || email || '';
    }
  }]);
}(ReduxRecord({
  acceptedStudentAccessCode: false,
  accountUuid: '',
  rootAccountUuid: '',
  allowBacktracking: true,
  allowClearMcSelection: null,
  authoritativeResult: null,
  choiceElimination: null,
  disableTimer: false,
  dueAt: null,
  elapsedTime: null,
  endAt: null,
  eventCreationToken: null,
  extraTimeInSeconds: null,
  id: '0',
  ipIsAllowed: null,
  kinesisCredentials: {},
  oneAtATimeType: null,
  quiz: null,
  // this is really a quizId
  quizSessionResults: List(),
  resultsFeedback: null,
  resultsFeedbackEnabled: false,
  resumeData: List(),
  sessionItems: List(),
  sessionItemsCount: null,
  startAt: null,
  status: '',
  takingData: Map(),
  timerMultiplier: null,
  user: Map(),
  // Good candidate for another Record - Still relevant?
  bolaSessionItemsCount: null,
  buildOnLastAttempt: null,
  multipleSessionAttempt: false
}));
export default QuizSession;